import React from 'react';
import { HyperText } from './HyperText';
const CompaniesSection = () => {
  return <div className="bg-black py-12 sm:py-20" data-id="element-2">
      <div className="max-w-7xl mx-auto px-4" data-id="element-3">
        <div className="text-center mb-6 sm:mb-8" data-id="element-4">
          <div className="flex justify-center" data-id="element-5">
            <HyperText text="CHECK OUT OUR PORTFOLIO COMPANIES" className="text-3xl sm:text-5xl md:text-5xl font-bold text-white tracking-normal" duration={1000} framerProps={{
            initial: {
              opacity: 0,
              y: -20
            },
            animate: {
              opacity: 1,
              y: 0
            },
            exit: {
              opacity: 0,
              y: 10
            }
          }} data-id="element-6" />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-7">
          <div className="bg-gray-900/50 p-6 sm:p-8 rounded-2xl border border-gray-800/50" data-id="element-8">
            <div className="flex flex-col" data-id="element-9">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/b564JEo2Cng5NR5KzkMCk1/clpng.png" alt="Cognitive Leverage Logo" className="h-12 sm:h-16 mb-4 sm:mb-6 mx-auto" data-id="element-10" />
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3 sm:mb-4 font-mono text-left" data-id="element-11">
                THE COGNITIVE LEVERAGE GROUP
              </h3>
              <p className="text-sm sm:text-base text-gray-300 mb-6 sm:mb-8 text-left" data-id="element-12">
                The Cognitive Leverage Group is a firm dedicated to building
                proprietary brands for investment firms, family offices, and
                leaders in private equity. Our experience in content strategy
                has helped generate billions of monthly organic impressions, and
                is now aimed at helping the world's most elite dealmakers.
              </p>
              <a href="http://www.cognitiveleverage.com" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-block px-6 py-3 bg-custom-green hover:bg-custom-green/90 text-black font-medium rounded-lg transition-all transform hover:scale-105 text-center" data-id="element-13">
                Learn More
              </a>
            </div>
          </div>
          
        </div>
      </div>
    </div>;
};
export default CompaniesSection;